module.exports = __webpack_public_path__ + "static/img/clix.650ffc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/coach/clix.png
// module id = raZg
// module chunks = 35